export default __webpack_public_path__ + "static/banner2-9d3b02c954b02f8233da860852589286.jpg";